module.exports = __webpack_public_path__ + "static/media/mohamedsamir1495.cffbe4a7.jpg";